export default __webpack_public_path__ + "static/media/promo_coda__b4z92qy59piq_medium.846d1033.jpg";